module.exports = __webpack_public_path__ + "Flaticon.be107ab9e1a6398db528.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/global-css/fonts/font/Flaticon.eot
// module id = ./src/app/global-css/fonts/font/Flaticon.eot
// module chunks = main